import React, { useState } from 'react';
import Box from '@mui/material/Box';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import TextField from '@mui/material/TextField';
import Chip from '@mui/material/Chip';

export const BasicSelect = ({ items = [], SelectedValue, Changehandler, label = "" }) => {
    const [age, setAge] = useState('');

    const handleChange = (event) => {
        setAge(event.target.value);
    };

    return (
        <Box sx={{ minWidth: 120, borderRadius: '6px', borderWidth: '2px' }}>
            <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label" sx={{ background: '#fff' }}>{label}</InputLabel>
                <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={SelectedValue}
                    label={label}
                    onChange={Changehandler}
                >
                    <MenuItem style={{ fontSize: '12px' }} value={""}>Select Option</MenuItem>
                    {
                        items && items?.length > 0 ? items?.map((value, index) => {
                            return (
                                <MenuItem style={{ fontSize: '12px' }} id={index} value={value?.value}>{value?.name}</MenuItem>
                            )
                        })
                            : ''}
                </Select>
            </FormControl>
        </Box>
    );
}


export const TextFieldChips = ({ selectedValue = [], type, changeHandler, label }) => {

    const [inputValue, setInputValue] = useState("");

    const handleKeyDown = (e) => {
        if (e.key === 'Enter' && inputValue.trim() !== "" && inputValue?.length > 5) {
            e.preventDefault();
            changeHandler(inputValue.trim());
            setInputValue("");
        }
    };

    const handleDelete = (chipToDelete) => {
        const updatedChips = selectedValue.filter(chip => chip !== chipToDelete);
        changeHandler(updatedChips, true);
    };
    return (
        <>
            <TextField
                fullWidth
                label={label}
                variant="outlined"
                value={inputValue}
                onChange={(e) => setInputValue(e.target.value)}
                onKeyDown={handleKeyDown}
                sx={{
                    ".MuiInputLabel-formControl": {
                        background: '#fff'
                    }
                }}
                
            />
            <Box sx={{ mt: 1, display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                {selectedValue.map((value, index) => (
                    <Chip key={index} label={value} onDelete={() => handleDelete(value)} />
                ))}
            </Box>
        </>
    )
}